import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { formatDate, penceToCurrency, STATUS } from "../../helpers/utils"
import { faCheck, faCircleXmark, faFloppyDisk, faWarning } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"
import ELNStore from "../../store"



export const Record = ({recordType, data, isOld, hasBefore}) => {
        if ((Array.isArray(data) && !data.length) || !data) return ''
        if (recordType === 'O') return <MiniOrder isOld={isOld} order={data} hasBefore={hasBefore} />
        if (recordType === 'P') return <MiniProduct isOld={isOld} product={data}  />
        return ''
    }

export const LogItem = ({item}) => {
    let iconName = faCheck
    if (item.status === STATUS.ERR) iconName = faCircleXmark
    else if (item.status === STATUS.WARN) iconName = faWarning
    else if (item.status === STATUS.CHANGES) iconName = faFloppyDisk

    const [open, setOpen] = useState(item.status === STATUS.CHANGES)
    
    const toggleOpen = () => {
        setOpen(o => !o)
    }
    return (
        <div className={`log-item log-status-${item.status}`}>
            <div className={'log-row'} onClick={toggleOpen}>
                <FontAwesomeIcon icon={iconName} />
                {item.recordType === 'P' && item.recordID && <span>PID <b>{item.recordID}</b></span>}
                {item.recordType === 'O' && item.recordID && <span>PO NUM <b>{item.recordID}</b></span>}
                <span>{item.message}</span>
            </div>
            {open && (item.beforeData || item.afterData) &&
            <div className={'log-data'}>
                {item.beforeData && item.afterData.changesMade && <Record isOld recordType={item.recordType} data={item.beforeData} />}
                {item.afterData && <Record recordType={item.recordType} data={item.afterData} hasBefore={item.beforeData} />}
            </div>
            }
        </div>
    )
}

export const MiniOrder = ({order, isOld, hasBefore}) => {
        
        const shops = ELNStore.useState(s => s.shops);
        const products = ELNStore.useState(s => s.products);

        const shop = shops.find(s => s.id === order.shop_id)

        const quantityTotal = order.orderProducts?.reduce((acc, op) => ( acc + (op.quantity) ), 0);
        const priceTotal = order.orderProducts?.reduce((acc, op) => ( acc + (op.quantity * op.unit_cost) ), 0);

        order.orderProducts = order.orderProducts?.map(op => {
            
            const product = op.testRun_product || products.find(p => p.id === op.product_id)

            return {...op, p_name: product?.name || '?', c_pos: String(product?.categories?.position).padStart(4, '0') || '0000', c_name: product?.categories?.name || ''}
        }).sort((a,b) => `${a.c_pos} ${a.p_name}` > `${b.c_pos} ${b.p_name}` ? 1 : -1)

        let quantityDiff = false
        let costDiff = false

        let tag = 'NEW'
        if (isOld) tag = 'OLD'
        if (!isOld && hasBefore && !order.changesMade) tag = 'NO CHANGES'
        
        return (
            <div className={`mini-record`}>
            <span>{tag}</span>
            <table>
                <tr>
                    <td className='center' colspan='5'>
                        {shop && <h2>{shop.brands?.name} - {shop.name}</h2>}
                        For delivery on<br/>
                        <h2>{formatDate(order.delivery_dt, false)}</h2>
                        ORDER ID: <b>{order.id || '?'}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; PO num: <b>{order.purchase_order_num}</b>
                    <br/>
                    </td>
                </tr>
                {order.orderProducts?.map(op => {
                    
                    if (op.quantityDiff) quantityDiff = true 
                    if (op.costDiff) costDiff = true 

                    return (
                        <tr>
                            <td>{op.c_name}</td>
                            <td>{op.p_name}</td>
                            <td className={`right ${op.quantityDiff ? 'different' : ''}`}>{op.quantity}</td>
                            <td className={`right ${op.costDiff ? 'different' : ''}`}>{penceToCurrency(op.unit_cost)}</td>
                            <td className={`right ${(op.costDiff || op.quantityDiff) ? 'different' : ''}`}>{penceToCurrency(op.unit_cost * op.quantity)}</td>
                        </tr>
                    )
                })}
                <tr className='mini-order-totals'>
                    <td colSpan='2'>TOTAL</td>
                    <td className={`right ${quantityDiff ? 'different' : ''}`}>{quantityTotal}</td>
                    <td></td>
                    <td className={`right ${costDiff ? 'different' : ''}`}>{penceToCurrency(priceTotal)}</td>
                </tr>
                <tr>
                    <td colspan='5'><i>{order.notes}</i></td>
                </tr>
            </table>
            </div>
        )
 
    }


export const MiniProduct = ({product, isOld}) => {

    const suppliers = ELNStore.useState(s => s.suppliers);
    const categories = ELNStore.useState(s => s.categories);
        
    const products = product.length ? product : [product]

        return (
            <div className='mini-record'>
                <span>{isOld ? 'OLD' : 'NEW'}</span>    
                <table>
                    <tr>
                        <th>PID</th>
                        <th>Category</th>
                        <th>Supplier</th>
                        <th>Name</th>
                        <th>Details</th>
                        <th>Unit Cost</th>
                    </tr>
                {
                    products.map(product => {
                        
                        const supplier = suppliers.find(s => s.id === product.supplier_id)
                        const category = categories.find(s => s.id === product.category_id)
                        
                        return (
                        <tr>
                            <td>{product.pid}</td>
                            <td>{category?.name || ''}</td>
                            <td>{supplier?.name || ''}</td>
                            <td>{product.name}</td>
                            <td>{product.details}</td>
                            <td>{penceToCurrency(product.unit_cost)}</td>
                        </tr>
                        )
                    })}
                </table>
            </div>
        )
    }


